



















































import BaseComponent from '@/components/base-component.vue';
import { DisparoWhatsappParmDTO } from '@/interfaces/pending-prescriptions';
import { listPendingPrescriptionWhatsappVariables, sendPendingPrescriptionWhatsappMessage } from '@/services/pending-prescriptions';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import UiDatePicker from '../UI/date-picker.vue';

@Component({
  components: {
    UiDatePicker
  }
})
export default class PendingPrescriptionWhatsappModal extends BaseComponent {
  @Prop()
  public item;

  dialogFlag = false;
  phone = null;
  parm: any = {};

  variables = [];

  public headers: any = [
    { text: 'Referência', value: 'id', sortable: false },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Valor', value: 'descricao', sortable: false },
  ];

  public form: any = {
    valid: false,
    rules: {
      phone: [(v) => v != null || 'Informe o Celular de teste'],
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  loading = false;
  error = false;
  items = null;

  mounted() {
    
    setTimeout(() => {
      this.dialogFlag = true;
    }, 10);

    setTimeout(() => {
      this.$refs['phone'].focus();
    }, 200);
  }

  @Watch('item', {immediate: true})
  onChangeItem() {
    this.loading = true;
    listPendingPrescriptionWhatsappVariables(this.item.id).subscribe(res => {
      this.variables = res;
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  closeForm() {
    this.$emit('close');
  }

  send() {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Enviando ...');
    let parm = new DisparoWhatsappParmDTO();
    parm.idPendencia = this.item.id;
    parm.phone4Test = this.phone;

    sendPendingPrescriptionWhatsappMessage(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show(res, 'success');
        this.$emit('sent');
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }
}
